const ITEMS = ["YOUR GOVERNMENT", "YOUR VOICE", "OUR SHARED VISION", "LISTEN BEFORE WE LEAD", "PEOPLE BEFORE PROJECTS", "TRUTH BEFORE POLITICS"];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-4xl text-[#F8F9FA]/85 whitespace-nowrap px-8 md:px-12">
            {item}
          </span>
          <svg viewBox="0 0 10 10" className="w-2.5 h-2.5 shrink-0" aria-hidden="true">
            <rect x="1.8" y="1.8" width="6.4" height="6.4" transform="rotate(45 5 5)" fill="#D4AF37" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden bg-navy border-y border-white/10 py-6 md:py-8"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
